var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.0001H16C16.7072 14.0001 17.3855 14.281 17.8856 14.7811C18.3857 15.2812 18.6667 15.9595 18.6667 16.6667C18.6667 17.374 18.3857 18.0523 17.8856 18.5524C17.3855 19.0525 16.7072 19.3334 16 19.3334H10.6667C10.4899 19.3334 10.3203 19.2632 10.1953 19.1382C10.0702 19.0131 10 18.8436 10 18.6667V9.33341C10 9.1566 10.0702 8.98703 10.1953 8.86201C10.3203 8.73699 10.4899 8.66675 10.6667 8.66675H15.3333C16.0406 8.66675 16.7189 8.9477 17.219 9.4478C17.719 9.94789 18 10.6262 18 11.3334C18 12.0407 17.719 12.7189 17.219 13.219C16.7189 13.7191 16.0406 14.0001 15.3333 14.0001",
    stroke: "#2A3D4A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarBold);
export default __webpack_public_path__ + "static/media/toolbar-bold.2c0bb7b6788f3c6db89fa6bdd9db47c3.svg";
export { ForwardRef as ReactComponent };